// Motivos de uma trava de compliance (Parte 5.2 a–d; REQ-AUTHZ-007; Parte 0.3 regra 6: trava é bloqueio, nunca aviso): a lista dos `blockingConstraints[]` do
// 423 `AUTHZ_DELEGATION_BLOCKED` — ou dos motivos de uma tentativa registrada — traduzida por `authz:delegations.blocked.reasons.<código>`, com o `detail`
// técnico como reserva para um código que o front ainda não conhece. O servidor devolve TODOS os motivos de uma vez; o PI regulariza tudo e tenta de novo.
import { Alert, AlertDescription, AlertTitle } from '@giyus/ui';
import { useTranslation } from 'react-i18next';

import type { DelegationBlockReason } from '../../api/delegations';
import { useReasonText } from './useReasonText';

export interface DelegationBlockedReasonsProps {
  readonly reasons: readonly DelegationBlockReason[];
  /** Nomes das tarefas do catálogo, por código (o motivo cita a tarefa pelo código). */
  readonly taskNames?: ReadonlyMap<string, string> | undefined;
  /** Sem o aviso "bloqueada…" (a tabela de tentativas lista só os motivos). */
  readonly bare?: boolean | undefined;
  readonly testId?: string | undefined;
}

export function DelegationBlockedReasons({
  reasons,
  taskNames,
  bare = false,
  testId = 'blocked-reasons',
}: DelegationBlockedReasonsProps) {
  const { t } = useTranslation('authz');
  const text = useReasonText();
  const list = (
    <ul className="list-disc pl-5" data-testid={bare ? testId : `${testId}-list`}>
      {reasons.map((reason, index) => (
        <li
          key={`${reason.code}-${reason.certificationTypeCode ?? ''}-${reason.taskCode ?? ''}-${reason.councilCode ?? ''}-${String(index)}`}
          data-testid="blocked-reason"
          data-code={reason.code}
        >
          {text(reason, taskNames)}
        </li>
      ))}
    </ul>
  );
  if (bare) {
    return list;
  }
  return (
    <Alert variant="destructive" role="alert" data-testid={testId}>
      <AlertTitle>{t('delegations.blocked.title')}</AlertTitle>
      <AlertDescription>
        <p>{t('delegations.blocked.description')}</p>
        {list}
      </AlertDescription>
    </Alert>
  );
}
